module.exports = new __parcel__URL__("database.2a5a6e18.gif").toString();